exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expense-representation .form__text-plus {\n  max-width: 49rem;\n  margin: 0 auto;\n}\n\n", ""]);

// exports
